export interface Ordered {
    order: number;
}

export default class OrderHelper {
    static getOrderOfNewItem(existingItems: Ordered[], insertAt?: number) {
        if(existingItems.length === 0) {
            return 0
        } else if(insertAt === undefined || insertAt >= existingItems.length) {
            return existingItems[existingItems.length - 1].order + 1
        } else if(insertAt === 0) {
            return existingItems[0].order - 1
        } else {
            return (existingItems[insertAt].order + existingItems[insertAt - 1].order) / 2
        }
    }
}